import React, { useState } from 'react';
import './RequestDemoSection.scss';

const RequestDemoSection = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    organization: '',
    email: '',
    phone: '',
    companySize: '',
    inquiryType: '',
    message: '',
    captcha: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  return (
    <section className="request-demo section">
      <div className="container">
        <div className="request-demo__content">
          <div className="request-demo__info">
            <h2 className="request-demo__title">REQUEST DEMO</h2>
            <p className="request-demo__description">
              Learn how an AI chatbot virtual assistant could improve your business
            </p>
            <div className="request-demo__contact">
              <div className="request-demo__contact-item">
                <i className="request-demo__icon request-demo__icon--phone"></i>
                <span>Give us a call<br />+1-619 373 1918</span>
              </div>
              <div className="request-demo__contact-item">
                <i className="request-demo__icon request-demo__icon--email"></i>
                <span>Send us an email<br />info@skil.ai</span>
              </div>
              <div className="request-demo__contact-item">
                <i className="request-demo__icon request-demo__icon--location"></i>
                <span>Drop by and talk<br />15 Corporate Pl S, Ste: 213B, Piscataway, NJ – 08854</span>
              </div>
            </div>
          </div>

          <form className="request-demo__form" onSubmit={handleSubmit}>
            <div className="request-demo__form-group">
              <input
                type="text"
                name="fullName"
                placeholder="Full Name*"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="request-demo__form-group">
              <input
                type="text"
                name="organization"
                placeholder="Organization*"
                value={formData.organization}
                onChange={handleChange}
                required
              />
            </div>
            <div className="request-demo__form-group">
              <input
                type="email"
                name="email"
                placeholder="Work Email Address*"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="request-demo__form-group">
              <input
                type="tel"
                name="phone"
                placeholder="Phone*"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
            <div className="request-demo__form-group">
              <select
                name="companySize"
                value={formData.companySize}
                onChange={handleChange}
                required
              >
                <option value="">Company Size*</option>
                <option value="1-10">1-10 employees</option>
                <option value="11-50">11-50 employees</option>
                <option value="51-200">51-200 employees</option>
                <option value="201-500">201-500 employees</option>
                <option value="501+">501+ employees</option>
              </select>
            </div>
            <div className="request-demo__form-group">
              <select
                name="inquiryType"
                value={formData.inquiryType}
                onChange={handleChange}
                required
              >
                <option value="">What is your inquiry about?*</option>
                <option value="demo">Request Demo</option>
                <option value="pricing">Pricing Information</option>
                <option value="support">Technical Support</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div className="request-demo__form-group">
              <textarea
                name="message"
                placeholder="How we can help you?*"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <div className="request-demo__form-group">
              <div className="request-demo__captcha">
                <input
                  type="text"
                  name="captcha"
                  placeholder="Captcha Code*"
                  value={formData.captcha}
                  onChange={handleChange}
                  required
                />
                <div className="request-demo__captcha-image">
                  {/* Captcha image will be added here */}
                </div>
              </div>
            </div>
            <button type="submit" className="button button--primary">
              Submit Now
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default RequestDemoSection; 
